import React from "react";
import { useMsal } from "@azure/msal-react";

const loginRequest = {
  scopes: [process.env.REACT_APP_SCOPES],
};

export function ProtectedApp({ children }) {
  const { instance, accounts, inProgress } = useMsal();

  React.useEffect(() => {
    if (inProgress === "none" && accounts.length === 0) {
      console.log("Triggering loginRedirect...");
      instance.loginRedirect(loginRequest);
    }
  }, [inProgress, accounts, instance]);

  if (inProgress !== "none") {
    return <p>MSAL state: {inProgress}</p>;
  }

  if (accounts.length === 0) {
    return <p>No account detected</p>;
  }

  return children;
}
